<template>
  <!-- color coded alerts-->
  <div class="ap-thread-create-activity-qustions-color-picker">
    <b-row class="ap-color-picker-main-container">
      <b-col class="ap-thread-color-alert-label">
        Select an alert color
      </b-col>
      <b-col class="p-0 col-1">
        <div>
          <div @click="showHideDropdown()" @blur="showHideDropdown()" class="color-picker-dropdown-outer" :class="{ 'text-align': showDropdown }">
            <div class="color-code" :class="{ 'ml-5 pull-left text-align': !showDropdown }" :style="{ 'background-color': colorCode }"></div>
            <div class="ml-35" v-if="!showDropdown">
              <i class="fa fa-caret-down fs-20 arrow-icon-color" aria-hidden="true"></i>
            </div>
          </div>
          <div v-show="showDropdown" class="ap-activity-library-qustion-color-dropdown-inner">
            <div v-for="(colorOption, index) in colorOptions" :key="index">
              <label @click="hideDropdown(index)" v-if="colorOption !== colorCode" class="color-code-label">
                <input type="radio" style="display:none;" :value="colorOption" name="color" v-model="colorCode" />
                <div class="color-code-outer">
                  <div class="color-code" :style="{ 'background-color': colorOption }"></div>
                </div>
              </label>
            </div>
          </div>
        </div>
      </b-col>
      <b-col class="col-9 pl-7 pr-27">
        <b-form-input type="text" v-model="warningMessage" placeholder="Enter an alert message" size="sm" class="fs-15 form-control ap-thread-alert-box-text"> </b-form-input>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object
    },
    colorValue: String,
    warningMsg: String
  },
  data() {
    return {
      colorOptions: ["#fff", "#f16559", "#ffa800", "#48bf7a"],
      colorOption: "",
      showDropdown: false
    };
  },
  computed: {
    colorCode: {
      get() {
        return this.colorValue;
      },
      set(val) {
        this.$emit("colorCodeChange", val);
      }
    },
    warningMessage: {
      get() {
        return this.warningMsg;
      },
      set(val) {
        this.$emit("warningMessageChange", val);
      }
    }
  },
  methods: {
    showHideDropdown() {
      this.showDropdown = !this.showDropdown;
      this.$forceUpdate();
    },
    hideDropdown() {
      this.showDropdown = false;
      this.$forceUpdate();
    }
  }
};
</script>
<style lang="scss" scoped>
.ap-thread-create-activity-qustions-color-picker {
  .ap-color-picker-main-container {
    display: flex;
    align-items: center;
    .ap-thread-color-alert-label {
      max-width: 10.5% !important;
      padding: 0px !important;
      color: #666669;
    }
    .ap-thread-alert-box-text {
      font-weight: normal;
      color: #000000;
      font-size: 12px;
      letter-spacing: normal;
    }
    .arrow-icon-color {
      color: #e4e8eb;
    }

    .text-align {
      text-align: -webkit-center;
    }

    .color-code-label {
      width: 100%;
      text-align: -webkit-center;
      display: block;
      margin-bottom: 0 !important;
      cursor: pointer;
    }

    .color-code-outer {
      border: 1px solid #e4e8eb;
      padding: 5px 22px;
      width: 100%;
    }

    .color-code {
      height: 20px;
      width: 20px;
      border-radius: 20px;
      border: solid 2px #d3dee3;
    }

    .color-picker-dropdown-outer {
      border: 1px solid #ced4da;
      border-radius: 0.2rem;
      padding: 5px;
      background-color: #ffffff;
      cursor: pointer;
    }
    .col-1 {
      max-width: 5.333333%;
    }

    .ap-activity-library-qustion-color-dropdown-inner {
      position: absolute;
      z-index: 200;
      width: 100%;
      background-color: #ffffff;
    }
  }
}
</style>
